import PropTypes from "prop-types";

function CustomLegend({ comparisons, legendOffsetY, isRotate }) {
  const calculateWidth = (text) => {
    const charCount = text.length;
    const words = text.split(' ');
    const longestWordLength = Math.max(...words.map(word => word.length));
    
    // Base width calculation
    let baseWidth = 200; // Default smaller width for short text
    // Only start increasing width after 30 characters
    if (charCount <= 30) {
      // For short text, keep width minimal
      baseWidth = Math.max(180, longestWordLength * 10);
    } else if (charCount <= 40 && charCount > 30) {
      // For text that needs two lines, gradually increase width
      const excess = charCount - 30;
      baseWidth = 170 + (excess * 5);
    }
    else if (charCount <= 50 && charCount > 40) {
      // For text that needs two lines, gradually increase width
      const excess = charCount - 30;
      baseWidth = 130 + (excess * 5);
    }
     else if (charCount <= 75 && charCount > 60){
      // For very long text (>60 chars), use 3 lines and reduce width to 180
      baseWidth = 260;
    }
    else if (charCount <= 90 && charCount > 75){
      // For very long text (>60 chars), use 3 lines and reduce width to 180
      baseWidth = 220;
    }
    else if (charCount <= 105 && charCount > 90){
      // For very long text (>60 chars), use 3 lines and reduce width to 180
      baseWidth = 250;
    }
    else if (charCount <= 120 && charCount > 105){
      // For very long text (>60 chars), use 3 lines and reduce width to 180
      baseWidth = 280;
    }

    // Additional adjustment for extremely long words
    const wordAdjustment = longestWordLength > 15 ? (longestWordLength - 15) * 12 : 0;
    
    return Math.max(baseWidth + wordAdjustment, 180); // Ensure minimum width
  };

  const getWidthClass = (textLength) => {
    if (textLength <= 30) return 'custom-legend__item--width-small';
    if (textLength <= 60) return 'custom-legend__item--width-medium';
    if (textLength <= 75) return 'custom-legend__item--width-large';
    if (textLength <= 90) return 'custom-legend__item--width-xl';
    if (textLength <= 105) return 'custom-legend__item--width-xxl';
    if (textLength <= 120) return 'custom-legend__item--width-xxxl';
    return 'custom-legend__item--width-xxxl';
  };

  const getTextClass = (textLength) => {
    return textLength > 75 ? 'custom-legend__item-text--three-lines' : 'custom-legend__item-text--two-lines';
  };

  // Calculate dynamic gap based on content and available space
  const containerWidth = typeof window !== 'undefined' ? window.innerWidth - 40 : 1200;
  const minGap = 30;
  const maxGap = 60;
  const gap = Math.max(minGap, Math.min(maxGap, (containerWidth * 0.05)));

  return (
    <div 
      className={`custom-legend ${isRotate ? 'custom-legend--rotated' : ''}`}
      style={{
        gap: `${gap}px`,
        marginTop: isRotate ? legendOffsetY + 160 : '10px',
      }}
    >
      {comparisons?.map(({ key, name = "", color, borderColor }) => {
        const itemWidth = calculateWidth(name);
        const textLength = name.length;
        return (
          <div
            key={key}
            className={`custom-legend__item ${getWidthClass(textLength)}`}
            style={{ width: itemWidth }}
          >
            <div
              className="custom-legend__item-color"
              style={{
                backgroundColor: color,
                border: `1.5px solid ${borderColor || "#000"}`,
              }}
            />
            <div className={`custom-legend__item-text ${getTextClass(textLength)}`}>
              {name}
            </div>
          </div>
        );
      })}
    </div>
  );
}

CustomLegend.propTypes = {
  comparisons: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      name: PropTypes.string,
      color: PropTypes.string.isRequired,
      borderColor: PropTypes.string
    })
  ),
  legendOffsetY: PropTypes.number,
  isRotate: PropTypes.bool
};

CustomLegend.defaultProps = {
  comparisons: [],
  legendOffsetY: 0,
  isRotate: false
};

export default CustomLegend;